import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { useCallback, useContext, useEffect } from "react";
import { Button } from "reactstrap";
import { ISharedObject } from "../../app/models/dto";
import { RootStoreContext } from "../../app/stores/rootStore";
import InfoMessage from "../common/InfoMessage";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import ProtectedZwibblerDiv from "../common/ProtectedZwibblerDiv";
import ProtectedVideo from "../common/ProtectedVideo";
import { toast } from "react-toastify";

const SyncScreen = () => {
  const rootStore = useContext(RootStoreContext);
  const { synchronizationObject  } = rootStore.playerStore;
  const { disableShareSync } = rootStore.tenantStore;
  const {
    createSharedZwibblerContext,
    destroySharedZwibblerContext,
    ZwibblerSharedOverlayResize,
    initializeSharedZwibblerContainer,
    zwibblerSharedDivStyle,
  } = rootStore.zwibblerStore;
  const { theme, setAutoSync } = rootStore.commonStore;
  const [t] = useTranslation(["features"], translationHookOptions);
  const zwibblerDivId = `zwibblerSharedDiv`;

  useEffect(() => {
    document.body.classList.add("p-0", "overflow-hidden");

    return () => {
      document.body.classList.remove("p-0", "overflow-hidden");
      destroySharedZwibblerContext();
    };
  }, [destroySharedZwibblerContext]);

  const handleZwibblerContext = useCallback(() => {
    return createSharedZwibblerContext(zwibblerDivId);
  }, [createSharedZwibblerContext, zwibblerDivId]);

  const renderSyncObject = (syncObj: ISharedObject) => {

    switch (syncObj.type) {
      case "image":
        return (
          <ProtectedZwibblerDiv
            url={syncObj.data}
            addZwibblerLayer={syncObj.command=="zoomportion" ? false: true}
            zwibblerDivId={"zwibblerSharedDiv"}
            zwibblerStyle={zwibblerSharedDivStyle}
            createZwibblerCtx={handleZwibblerContext}
            onImageLoad={initializeSharedZwibblerContainer}
            resizeHandler={ZwibblerSharedOverlayResize}
            className={classNames("image-gallery-common", "sync-slide")}
          />
        );
      case "video":
        return (
          <ProtectedVideo
            url={syncObj.data}
            isRendered={true}
            className={classNames("image-gallery-common", "sync-slide")}
          />
        );
      default:
        return (
          <InfoMessage
            message={t("sync_screen_not_implemented_content", {
              content_type: syncObj.type,
            })}
            icon="fas fa-exlamation-triangle fa-3x"
            color={theme!.infoMessageColor}
          />
        );
    }
  };

  return (
    <div className="sync-open">
      <Button
        className="sync-close-btn"
        close
        onClick={() => {
          disableShareSync();
          setAutoSync(false);
        }}
      >
        <i className="fas fa-times fa-2x sync-close-icon"></i>
      </Button>
      <div className="sync-slide">
        {synchronizationObject ? (
          renderSyncObject(synchronizationObject)
        ) : (
          <InfoMessage
            message={t("sync_screen_no_shared_content")}
            icon="fas fa-exlamation-triangle fa-3x"
            color={theme!.infoMessageColor}
          />
        )}
      </div>
    </div>
  );
};

export default observer(SyncScreen);
